module.exports = __webpack_public_path__ + "img/whatsapp.b50cc27.svg?v=1764327952164";